/**
 * `crypto.randomUUID()` 는 secure context(HTTPS)에서만 노출되며, 일부 인앱
 * 웹뷰/구형 브라우저(예: Samsung Internet 일부 빌드)에서는 `crypto` 는 있어도
 * `randomUUID` 가 없어 `crypto.randomUUID is not a function` 으로 throw 한다.
 *
 * 네이티브가 있으면 그대로 쓰고, 없으면 RFC4122 v4 형태의 fallback 을 생성한다.
 * (보안용 토큰이 아니라 클라이언트 상관관계 ID/주문 ID 용도이므로 fallback 이면 충분)
 */
export function safeRandomUUID(): string {
  const cryptoApi = globalThis.crypto;

  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID();
  }

  // getRandomValues 가 있으면 그것으로 v4 UUID 구성, 없으면 Math.random 폴백.
  const getRandomByte = (() => {
    if (typeof cryptoApi?.getRandomValues === 'function') {
      const buffer = new Uint8Array(1);
      return () => cryptoApi.getRandomValues(buffer)[0];
    }
    return () => Math.floor(Math.random() * 256);
  })();

  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, char => {
    const c = Number(char);
    return (c ^ (getRandomByte() & (15 >> (c / 4)))).toString(16);
  });
}
